import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { DisplayUrl } from "src/app/models/common/DisplayUrl";

@Component({
    selector: 'display-form',
    templateUrl: './display-form.component.html',
    styleUrls: ['./display-form.component.css']
})

export class DisplayFormComponent implements OnInit, OnChanges {
    ngOnInit(): void {
        this.updateDisplayModels();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.updateDisplayModels();
    }

    @Input() displayFields: string[] = [];    // ordered list of fields from the object to display
    @Input() displayObject: any;
    @Input() includeRefreshButton: boolean = false;

    @Output() refreshClicked = new EventEmitter<boolean>();
    displayValues: DisplayItem[] = [];

    emitRefresh() {
        this.refreshClicked.emit(true);
    }

    updateDisplayModels() {
        if (this.displayObject !== undefined) {
            this.displayValues = [];

            if (this.displayFields.length > 0) {
                this.displayFields.forEach(key => {
                    let val = this.displayObject[key];
                    if (val !== undefined) {
                        this.displayValues.push(new DisplayItem(key, val));
                    }
                });
            } else {
                Object.entries(this.displayObject).forEach(([key, value]) => {
                    this.displayValues.push(new DisplayItem(key, value));
                });
            }
        }
    }
}

class DisplayItem {

    constructor(key: string, value: any) {
        this.key = key;
        this.value = value;

        this.type = Array.isArray(value) ? 'array' : typeof (value);
        if (this.type === 'object' && DisplayUrl.isDisplayUrl(value)) {
            this.type = 'displayUrl';
        }
    }

    key: string;
    value: any;
    type: string;
}